import { makeStyles } from '@mui/styles';

export const muiStyles = makeStyles(() => ({
    container: {
        padding: '.75rem .3rem 0 .3rem',
        '&:last-child': { paddingBottom: '.75rem' }
    },
    tightContainer: { '&:last-child': { paddingBottom: '.75rem' }},
    label: {
        fontSize: '.9rem',
        lineHeight: '1.2rem',
        fontWeight: 'bold' as 'bold',
        color: '#4A4C50',
        paddingRight: '1rem'
    },
    attribute: {
        fontSize: '.75rem',
        color: '#54565B',
        wordBreak: 'break-all' as 'break-all'
    }
}));